import Mime from 'mime'

export const getFileIconPathByMimeType = (fileTypesIconDirectoryPath: string, mimeType: string): string => {
    let extension = Mime.getExtension(mimeType)
    const supportedExetensions = ['aac', 'ai', 'bmp', 'cdr', 'doc', 'docx', 'eps', 'pptx', 'gif', 'jpg', 'mkv', 'mov', 'mp3', 'mpeg', 'mpg',
        'pdf', 'png', 'ppt', 'ps', 'psd', 'svg', 'trf', 'txt', 'wma', 'xls', 'xlsx', 'zip', 'sql']

    if (extension === null || !supportedExetensions.includes(extension)) {
        extension = 'file'
    }
    return `${fileTypesIconDirectoryPath}/${extension}.svg`
}